export function setTypeVehicles(state, data) {
    state.typeVehicles = data;
}

export function setShowComponentVehicle(state, data) {
    state.showComponentVehicle = data;
}

export function setCountries(state, data) {
    state.countries = data;
}

export function setDataVehicle(state, vehicle_type_id) {
    const typeVehicles = state.typeVehicles.find(v => v.id === vehicle_type_id);

    if (typeVehicles) {
        state.dataVehicle = [
            {
                title: "Marca",
                value: typeVehicles.brand_vehicle.name_parameter
            },
            { title: "Tipo", value: typeVehicles.class_vehicle.name_parameter },
            {
                title: "Servicio",
                value: typeVehicles.servicio === 2 ? "Privado" : "Público"
            },
            { title: "Potencia", value: typeVehicles.power },
            { title: "Cilindraje", value: typeVehicles.cylinder_capacity },
            { title: "Peso", value: typeVehicles.weight },
            { title: "Tipo de caja", value: typeVehicles.box_type },
            { title: "Puertas", value: typeVehicles.doors },
            { title: "Combustible", value: typeVehicles.fuel },
            { title: "Nacionalidad", value: typeVehicles.nationality },
            {
                title: "Capacidad de pasajeros",
                value: typeVehicles.passenger_capacity
            },
            { title: "Transmisión", value: typeVehicles.transmission },
            { title: "Tipo de caja", value: typeVehicles.box_type }
        ];
    } else {
        state.dataVehicle = [];
    }
}

export function setContacts(state, contacts) {
    state.contacts = contacts;
}

export function setParamsContacts(state, filter) {
    state.params_client.filter = filter;
}

export function setClient(state, client) {
    state.client = client;
}

export function setParamsContactsContactId (state, contact_id) {
    state.params_client.contact_id = contact_id;
}



// WEBPACK FOOTER //
// ./src/modules/contact-vehicles/mutations.js